import { FC } from "react";
import { ContentProps } from "../../types";
import { FolderListItem } from "./folder-list-item";
import { FileListItem } from "./file-list-item";

export const List: FC<ContentProps> = (props) => {
  const { folderList, fileList, ...actions } = props;
  return (
    <ul className="list-group list-group-flush mb-4">
      {folderList.map((f, i) => (
        <FolderListItem key={i} item={f} {...actions} />
      ))}
      {fileList.map((f, i) => (
        <FileListItem
          key={i}
          item={f}
          moveFileActionAllowed={Boolean(folderList?.length)}
          {...actions}
        />
      ))}
    </ul>
  );
};
